module.exports = __webpack_public_path__ + "img/img-9.91fc1092.webp";